import React from 'react';
import {DownloadOutlined} from '@ant-design/icons';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import {FORMAT_BY_CODE, LEVEL_BY_CODE} from '../courses.enums';
import useLocalizedText from '../hooks/useLocalizedText';
import {hoursLabel, priceLabel} from '../courses.utils';
import {SHOW_PRICES, SHOW_PROGRAM_DOWNLOAD} from '../courses.config';

/**
 * Карточка записи в герое страницы курса. На десктопе она же прилипает при прокрутке
 * (position: sticky на родительской колонке), на узком экране становится обычной врезкой,
 * а её роль берёт на себя нижний закреплённый бар.
 */
const EnrollCard = ({course, onApply, onDownload}) => {
    const pick = useLocalizedText();
    const format = FORMAT_BY_CODE[course.format];
    const level = LEVEL_BY_CODE[course.level];

    return (
        <div className={classes.enrollCard}>
            <div>
                <p className={classes.enrollPrice}>
                    {SHOW_PRICES && course.priceTenge
                        ? priceLabel(course.priceTenge)
                        : <IntlMessage id="coursesPage.card.priceOnRequest"/>}
                </p>
                <p className={classes.enrollNote}>
                    <IntlMessage id="coursesPage.enroll.priceNote"/>
                </p>
            </div>

            <div className={classes.enrollDivider}/>

            <div className={classes.enrollSpecs}>
                <div className={classes.enrollRow}>
                    <span className={classes.enrollKey}><IntlMessage id="coursesPage.course.meta.format"/></span>
                    <span className={classes.enrollValue}>
                        {format && <IntlMessage id={format.labelKey}/>}
                    </span>
                </div>
                <div className={classes.enrollRow}>
                    <span className={classes.enrollKey}><IntlMessage id="coursesPage.course.meta.duration"/></span>
                    <span className={classes.enrollValue}>{hoursLabel(course.durationHours)}</span>
                </div>
                {/* строка появляется, только если в документе курса указана
                    вторая часть длительности — «2 дня», «12 недель» и подобное */}
                {(pick(course.durationShape) || '').trim() && (
                    <div className={classes.enrollRow}>
                        <span className={classes.enrollKey}><IntlMessage id="coursesPage.enroll.shape"/></span>
                        <span className={classes.enrollValue}>{pick(course.durationShape)}</span>
                    </div>
                )}
                <div className={classes.enrollRow}>
                    <span className={classes.enrollKey}><IntlMessage id="coursesPage.course.meta.level"/></span>
                    <span className={classes.enrollValue}>
                        {level && <IntlMessage id={level.labelKey}/>}
                    </span>
                </div>
                {course.minGroupSize && (
                    <div className={classes.enrollRow}>
                        <span className={classes.enrollKey}><IntlMessage id="coursesPage.enroll.minGroup"/></span>
                        <span className={classes.enrollValue}>{course.minGroupSize}</span>
                    </div>
                )}
            </div>

            <button type="button" className={`${classes.btnAccent} ${classes.btnBlock}`} onClick={onApply}>
                <IntlMessage id="coursesPage.enroll.button"/>
            </button>

            {/* Кнопка «Скачать программу» скрыта: PDF-файлов программ пока нет,
                и вести некуда. Вернётся, когда появятся файлы. */}
            {SHOW_PROGRAM_DOWNLOAD && (
                <button type="button" className={`${classes.btnGhost} ${classes.btnBlock}`} onClick={onDownload}>
                    <DownloadOutlined/>
                    <IntlMessage id="coursesPage.course.downloadPdf"/>
                </button>
            )}

            <p className={classes.enrollTrust}>
                <IntlMessage id="coursesPage.enroll.trust"/>
            </p>
        </div>
    );
};

/**
 * Нижний бар для узких экранов. Идёт во всю ширину, а не плавающей кнопкой в углу:
 * правый нижний угол уже занят глобальными BackTop и переключателем языка.
 */
export const MobileEnrollBar = ({course, visible, onApply}) => (
    <div className={`${classes.mobileBar} ${visible ? classes.mobileBarVisible : ''}`}>
        <div>
            <div className={classes.mobileBarPrice}>
                {SHOW_PRICES && course.priceTenge
                    ? priceLabel(course.priceTenge)
                    : <IntlMessage id="coursesPage.card.priceOnRequest"/>}
            </div>
            <div className={classes.mobileBarHours}>{hoursLabel(course.durationHours)}</div>
        </div>
        <button type="button" className={classes.btnAccent} onClick={onApply}>
            <IntlMessage id="coursesPage.enroll.buttonShort"/>
        </button>
    </div>
);

export default EnrollCard;
